import Link from 'next/link'
import { useTranslations } from 'packages/microsite-components/src/hooks'
import { Icon } from 'packages/microsite-components/src/icon-library'
import { useTrackingOnScreen } from 'packages/microsite-components/src/on-screen'
import { DigitalData } from 'packages/microsite-components/src/utils/digital-data'

export default function TakebackGalleryCard() {
  const { translate } = useTranslations()
  const ref = useTrackingOnScreen(() => {
    DigitalData.pushViewPromotion({
      creative_name: 'takeback',
      promotion_name: 'filter-page_banner',
      creative_slot: 'service_icons',
      promotion_id: '',
    })
  })

  const onClick = (selectedService: string) => {
    DigitalData.pushSelectPromotion({
      promotion_id: '',
      creative_name: selectedService,
      promotion_name: 'filter-page_banner',
      creative_slot: 'service_icons',
    })
  }

  return (
    <article className="u-mb-8 u-mb-sm-16 col-12 col-sm-6 col-md-4">
      <Link
        className="c-product-card c-product-card--gallery u-bg-dark-green u-color-light-green a-no-styling"
        href={translate('Link_Takeback')}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => onClick('takeback')}>
        <div className="d-flex flex-column gap-48">
          <Icon className="i-120 u-color-green align-self-center u-pt-48" name="leaf" />
          <div>
            <header ref={ref}>
              <h2 className="h4 u-color-green u-pb-4">{translate('Takeback_Card_Subheader')}</h2>
            </header>
            <p className="u-fs-14">{translate('Takeback_Card_Information')}</p>
          </div>
        </div>

        <Icon className="i-24 align-self-end" name="arrow-right" />
      </Link>
    </article>
  )
}
